export default __webpack_public_path__ + "static/media/Potion of Constitution (4h).7dcc2272.jpg";